exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.login h1 {\n  margin-bottom: 2rem;\n}\n", "", {"version":3,"sources":["/Users/marco/vitamin2/solarapp-frontend-management/src/components/pages/login/style.scss"],"names":[],"mappings":";AAAA;EAEE,oBAAmB;CACnB","file":"Login.vue","sourcesContent":[".login {\n\th1 {\n\t\tmargin-bottom: 2rem;\n\t}\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e89db78","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/login/Login.vue
// module id = 1OxY
// module chunks = 1